module.exports = __webpack_public_path__ + "static/img/con-bg2.bdfa328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/con-bg2.png
// module id = MoGO
// module chunks = 1